module.exports = __webpack_public_path__ + "img/album01_09.e7e23d38.jpg";